import { useState } from "react";
import userStore from "../zustand/userStore";
import { useDispatch } from "react-redux";
import { sponsorshipRegistrationThunk } from "../features/ticketing-app/redux/ticketingSlice";

const initialState = {
  schoolName: "",
  address: "",
  principalName: "",
  principalPhone: "",
  principalEmail: "",
  coordinatorName: "",
  coordinatorPhone: "",
  coordinatorEmail: "",
  classFrom: "",
  classTo: "",
  totalStudents: "",
  totalTeachers: "",
  board: "",
  schoolType: "",
  selectedPlan: "",
  customUserCount: "",
  requirementType: "",
  otherReqText: "",
  purpose: "",
  projectDesc: "",
  budget: "",
  outcomes: "",
  benefitStudents: "",
  benefitTeachers: "",
  benefitSchool: "",
  declarantName: "",
  declarantDesig: "",
  checkApproval: false,
  checkPublish: false,
  declarationDate: new Date().toISOString().split("T")[0],
};

const styles = {
  page: {
    background:
      "linear-gradient(135deg, #e8f4fd 0%, #f0f7ff 50%, #e8f0fe 100%)",
    padding: "32px 16px",
    // fontFamily: "'Georgia', serif",
  },
  card: {
    maxWidth: 820,
    margin: "0 auto",
    background: "#ffffff",
    borderRadius: 20,
    boxShadow: "0 8px 48px rgba(37,99,168,0.12)",
    overflow: "hidden",
  },
  header: {
    background: "linear-gradient(135deg, #1a3a5c 0%, #2563a8 100%)",
    padding: "20px 28px", // ⬅ reduced
    color: "#fff",
    height: "auto", // ⬅ remove fixed height
  },
  headerBadge: {
    display: "inline-block",
    background: "rgba(255,255,255,0.18)",
    color: "#fff",
    fontSize: 11,
    fontFamily: "'Verdana', sans-serif",
    fontWeight: 700,
    borderRadius: 20,
    padding: "3px 14px",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    marginBottom: 12,
  },
  headerTitle: {
    margin: "0 0 8px",
    fontSize: 22,
    fontWeight: 700,
    fontFamily: "'Georgia', serif",
  },
  headerSub: {
    margin: 0,
    fontSize: 13,
    opacity: 0.82,
    fontFamily: "'Verdana', sans-serif",
  },
  formBody: { padding: "36px 40px" },
  sectionBlock: {
    borderLeft: "4px solid #2563a8",
    paddingLeft: 20,
    marginBottom: 36,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: "#2563a8",
    // textTransform: "uppercase",
    letterSpacing: "0.1em",
    fontFamily: "'Verdana', sans-serif",
    margin: "0 0 18px",
  },
  subLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    fontFamily: "'Verdana', sans-serif",
    margin: "20px 0 10px",
  },
  row: { display: "flex", flexWrap: "wrap", gap: 16, marginTop: 14 },
  col12: { flex: "1 1 100%" },
  col6: { flex: "1 1 calc(50% - 8px)", minWidth: 200 },
  col3: { flex: "1 1 calc(25% - 12px)", minWidth: 130 },
  col4: { flex: "1 1 calc(33.33% - 11px)", minWidth: 160 },
  label: {
    display: "block",
    fontSize: 13,
    fontWeight: 600,
    color: "#374151",
    marginBottom: 5,
    fontFamily: "'Verdana', sans-serif",
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    padding: "10px 14px",
    fontSize: 14,
    border: "1.5px solid #c8d8ea",
    borderRadius: 8,
    background: "#ffffff",
    color: "#111827",
    outline: "none",
    fontFamily: "'Georgia', serif",
  },
  inputFocus: {
    borderColor: "#2563a8",
    background: "#ffffff",
    boxShadow: "0 0 0 3px rgba(37,99,168,0.10)",
  },
  select: {
    width: "100%",
    boxSizing: "border-box",
    padding: "10px 14px",
    fontSize: 14,
    border: "1.5px solid #c8d8ea",
    borderRadius: 8,
    background: "#ffffff",
    color: "#111827",
    outline: "none",
    fontFamily: "'Georgia', serif",
    cursor: "pointer",
  },
  textarea: {
    width: "100%",
    boxSizing: "border-box",
    padding: "10px 14px",
    fontSize: 14,
    border: "1.5px solid #c8d8ea",
    borderRadius: 8,
    background: "#ffffff",
    color: "#111827",
    outline: "none",
    fontFamily: "'Georgia', serif",
    resize: "vertical",
    minHeight: 80,
  },
  star: { color: "#dc2626", marginLeft: 2 },
  // styles
  planList: {
    display: "flex",
    flexWrap: "nowrap", // ✅ force single row always
    gap: 12,
    marginTop: 12,
  },

  planCard: {
    flex: "0 0 calc(25% - 9px)", // ✅ exactly 4 per row (gap: 12 → 3 gaps = 36px / 4 = 9px)
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "12px 14px", // ✅ slightly tighter padding
    borderRadius: 12,
    border: "1.5px solid #dbeafe",
    cursor: "pointer",
    background: "#fff",
    transition: "all 0.2s ease",
    boxSizing: "border-box", // ✅ padding included in width calc
  },

  planCardSelected: {
    borderColor: "#2563eb",
    background: "#eff6ff",
  },
  planLabel: {
    fontSize: 14,
    fontWeight: 700,
    color: "#1a3a5c",
    fontFamily: "'Verdana', sans-serif",
  },
  planSub: {
    marginLeft: "auto",
    fontSize: 12,
    color: "#6b7280",
    fontFamily: "'Verdana', sans-serif",
  },
  reqTypeLabel: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    border: "1.5px solid #dce8f5",
    borderRadius: 8,
    padding: "10px 14px",
    marginBottom: 8,
    cursor: "pointer",
    fontSize: 14,
    background: "#f8fbff",
    color: "#111827",
    fontFamily: "'Georgia', serif",
  },
  reqTypeLabelSelected: {
    border: "1.5px solid #2563a8",
    background: "#eff6ff",
    fontWeight: 600,
  },
  declarationBox: {
    background: "#f0f6ff",
    borderRadius: 12,
    padding: "22px 24px",
    border: "1.5px solid #c8d8ea",
  },
  declarationText: {
    fontSize: 13,
    color: "#374151",
    lineHeight: 1.7,
    marginBottom: 16,
    fontFamily: "'Georgia', serif",
  },
  checkLabel: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    fontSize: 13,
    color: "#374151",
    marginBottom: 12,
    fontFamily: "'Georgia', serif",
    cursor: "pointer",
    lineHeight: 1.6,
  },
  checkInput: {
    width: 16,
    height: 16,
    marginTop: 2,
    accentColor: "#2563a8",
    cursor: "pointer",
    flexShrink: 0,
  },
  btnPrimary: {
    background: "linear-gradient(90deg, #1a3a5c 0%, #2563a8 100%)",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 700,
    padding: "13px 40px",
    cursor: "pointer",
    fontFamily: "'Verdana', sans-serif",
    letterSpacing: "0.04em",
    boxShadow: "0 4px 16px rgba(37,99,168,0.20)",
  },
  btnSecondary: {
    background: "#fff",
    color: "#374151",
    border: "1.5px solid #c8d8ea",
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    padding: "13px 28px",
    cursor: "pointer",
    fontFamily: "'Verdana', sans-serif",
  },
  toast: {
    position: "fixed",
    bottom: 30,
    right: 30,
    background: "#166534",
    color: "#fff",
    borderRadius: 10,
    padding: "14px 26px",
    fontWeight: 600,
    fontSize: 14,
    boxShadow: "0 4px 20px rgba(0,0,0,0.18)",
    zIndex: 9999,
    fontFamily: "'Verdana', sans-serif",
    animation: "slideUp 0.3s ease",
  },
};

const plans = [
  //   { value: "25 Users", label: "25 Users", sub: "Starter" },
  //   { value: "50 Users", label: "50 Users", sub: "Basic" },
  //   { value: "100 Users", label: "100 Users", sub: "Standard" },
  //   { value: "100+ Users", label: "100+ Users", sub: "Custom" },
  { value: "25 Users", label: "25 Users", sub: "" },
  { value: "50 Users", label: "50 Users", sub: "" },
  { value: "100 Users", label: "100 Users", sub: "" },
  {
    value: "100+ Users",
    label: "100+ Users",
    sub: "(Please specify the count)",
  },
];

const reqTypes = [
  "Financial Grant",
  "Sponsorship (Events/Programs)",
  "Infrastructure Support",
  "Educational Materials",
  "Other",
];

/* ── Focusable primitives ── */
function FocusInput({ style, ...props }) {
  const [focused, setFocused] = useState(false);
  return (
    <input
      {...props}
      style={{
        ...styles.input,
        ...style,
        ...(focused ? styles.inputFocus : {}),
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    />
  );
}

function FocusTextarea({ style, ...props }) {
  const [focused, setFocused] = useState(false);
  return (
    <textarea
      {...props}
      style={{
        ...styles.textarea,
        ...style,
        ...(focused ? styles.inputFocus : {}),
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    />
  );
}

function FocusSelect({ style, children, ...props }) {
  const [focused, setFocused] = useState(false);
  return (
    <select
      {...props}
      style={{
        ...styles.select,
        ...style,
        ...(focused ? styles.inputFocus : {}),
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    >
      {children}
    </select>
  );
}

/* ── Main component ── */
export default function SchoolGrantForm({ isOpen, onClose }) {
  const [form, setForm] = useState(initialState);
  const [showToast, setShowToast] = useState(false);
  const userData = userStore((state) => state.user);
  const dispatch = useDispatch();
  const update = (field) => (e) =>
    setForm((p) => ({ ...p, [field]: e.target.value }));
  const updateCheck = (field) => (e) =>
    setForm((p) => ({ ...p, [field]: e.target.checked }));
  if (!isOpen) return null;

  // selectedPlan: "Plan",
  // schoolName: "School Name",
  // address: "Address",
  // principalName: "Principal Name",
  // principalMobile: "Principal Mobile Number",
  // classFrom: "Class From",
  // classTo: "Class To",
  // totalStudents: "Total Students",
  // totalTeachers: "Total Teachers",
  // board: "Board",
  // schoolType: "School Type",
  // contactPerson: "Contact Person",
  // contactDetails: "Contact Mobile Number",
  const fieldLabels = {
    schoolName: "School Name",
    address: "School Address",
    principalName: "Principal Name",
    principalPhone: "Principal Phone Number",
    principalEmail: "Principal Email",
    coordinatorName: "Coordinator Name",
    coordinatorPhone: "Coordinator Phone Number",
    coordinatorEmail: "Coordinator Email",
    classFrom: "Class From",
    classTo: "Class To",
    totalStudents: "Total Students",
    totalTeachers: "Total Teachers",
    board: "Education Board",
    schoolType: "School Type",
    selectedPlan: "Selected Plan",
    customUserCount: "Custom User Count",
    requirementType: "Requirement Type",
    otherReqText: "Other Requirement Details",
    purpose: "Purpose",
    projectDesc: "Project Description",
    budget: "Estimated Budget",
    outcomes: "Expected Outcomes",
    benefitStudents: "Benefits for Students",
    benefitTeachers: "Benefits for Teachers",
    benefitSchool: "Benefits for School",
    declarantName: "Declarant Name",
    declarantDesig: "Declarant Designation",
    checkApproval: "Approval Confirmation",
    checkPublish: "Publish Consent",
    declarationDate: "Declaration Date",
  };
  const baseRequiredFields = [
    "schoolName",
    "address",
    "principalName",
    "principalPhone",
    "principalEmail",
    "coordinatorName",
    "coordinatorPhone",
    "coordinatorEmail",
    "classFrom",
    "classTo",
    "totalStudents",
    "totalTeachers",
    "board",
    "schoolType",
    "selectedPlan",
    "requirementType",
    "purpose",
    "projectDesc",
    "budget",
    "outcomes",
    "benefitStudents",
    "benefitTeachers",
    "benefitSchool",
    "declarantName",
    "declarantDesig",
    "declarationDate",
  ];

  const validateForm = () => {
    const errors = [];

    // 1️⃣ Mandatory fields (BASE ONLY)
    baseRequiredFields.forEach((key) => {
      const value = form[key];
      if (!value || value.toString().trim() === "") {
        errors.push(fieldLabels[key]);
      }
    });

    // 2️⃣ Class range validation
    const from = Number(form.classFrom);
    const to = Number(form.classTo);
    if (!isNaN(from) && !isNaN(to) && from >= to) {
      errors.push("Class From must be LESS than Class To");
    }

    // 3️⃣ Conditional: 100+ Users
    if (form.selectedPlan === "100+ Users") {
      if (!form.customUserCount || Number(form.customUserCount) <= 100) {
        errors.push(
          "Custom User Count is mandatory and must be greater than 100",
        );
      }
    }

    // 4️⃣ Conditional: Requirement = Other
    if (form.requirementType === "Other") {
      if (!form.otherReqText || form.otherReqText.trim() === "") {
        errors.push(fieldLabels.otherReqText);
      }
    }

    // 5️⃣ Phone validations (FIXED KEYS)
    const phoneFields = [
      { value: form.principalPhone, label: fieldLabels.principalPhone },
      { value: form.coordinatorPhone, label: fieldLabels.coordinatorPhone },
    ];

    phoneFields.forEach(({ value, label }) => {
      if (!/^\d{10}$/.test(String(value))) {
        errors.push(`${label} must be exactly 10 digits`);
      }
    });

    // 6️⃣ Email validations
    const emailFields = [
      { value: form.principalEmail, label: fieldLabels.principalEmail },
      { value: form.coordinatorEmail, label: fieldLabels.coordinatorEmail },
    ];

    emailFields.forEach(({ value, label }) => {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        errors.push(`${label} is not a valid email address`);
      }
    });

    return errors;
  };

  const handleSubmit = async () => {
    const errors = validateForm();

    if (errors.length > 0) {
      alert(
        "Please correct the following:\n\n" +
          errors.map((e, i) => `${i + 1}. ${e}`).join("\n"),
      );
      return;
    }

    const finalData = {
      school_user_id: userData?.admin_id,
      "A. School Details": {
        schoolName: form.schoolName,
        address: form.address,
        principal: {
          name: form.principalName,
          phone: form.principalPhone,
          email: form.principalEmail,
        },
        coordinator: {
          name: form.coordinatorName,
          phone: form.coordinatorPhone,
          email: form.coordinatorEmail,
        },
        classes: `${form.classFrom} to ${form.classTo}`,
        totalStudents: form.totalStudents,
        totalTeachers: form.totalTeachers,
        board: form.board,
        schoolType: form.schoolType,
      },
      "B. MyDocMaster Plan": {
        selectedPlan: form.selectedPlan,
        customUserCount:
          form.selectedPlan === "100+ Users" ? form.customUserCount : "N/A",
      },
      "C. Grant / Sponsorship Details": {
        requirementType:
          form.requirementType === "Other"
            ? `Other: ${form.otherReqText}`
            : form.requirementType,
        purpose: form.purpose,
        projectDescription: form.projectDesc,
        estimatedBudget: form.budget,
        expectedOutcomes: form.outcomes,
        benefits: {
          students: form.benefitStudents,
          teachers: form.benefitTeachers,
          school: form.benefitSchool,
        },
      },
      Declaration: {
        name: form.declarantName,
        designation: form.declarantDesig,
        agreedToApprovalClause: form.checkApproval,
        authorisedDataPublish: form.checkPublish,
        date: form.declarationDate,
      },
    };

    console.log(finalData);
    const action = await dispatch(sponsorshipRegistrationThunk(finalData));
    console.log("action", JSON.stringify(action));
    // ✅ SUCCESS
    if (sponsorshipRegistrationThunk.fulfilled.match(action)) {
      const message =
        action.payload?.message ||
        "Sponsorship registration submitted successfully!";

      alert(message); // waits until OK clicked
      window.location.reload(); // reload after OK
    }

    // ❌ ERROR
    if (sponsorshipRegistrationThunk.rejected.match(action)) {
      const errorMsg =
        action.payload?.message || "Something went wrong. Please try again.";

      alert(errorMsg);
    }
  };

  const handleReset = () => {
    setForm(initialState);
    console.log("%c🔄 Form Reset", "color:#6b7280;font-style:italic;");
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: "16px", // breathing room on small screens
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          padding: 0, // ✅ let SchoolGrantForm control its own padding
          maxWidth: "900px", // ✅ wide enough for the form (was 400px)
          width: "95%", // ✅ fixed typo (was "1090%")
          maxHeight: "90vh", // ✅ don't overflow the screen
          overflowY: "auto", // ✅ scroll inside popup if form is tall
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={styles.page}>
          <style>{`
        @keyframes slideUp { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
        input[type="radio"]    { accent-color:#2563a8; width:17px; height:17px; cursor:pointer; }
        input[type="checkbox"] { accent-color:#2563a8; }
        select option          { background:#fff; color:#111827; }
      `}</style>

          <div style={styles.card}>
            {/* ── HEADER ── */}
            <div style={styles.header}>
              {/* <span style={styles.headerBadge}>MyDocMaster CSR Initiative</span> */}
              <h1 style={styles.headerTitle}>
                School Grant / Sponsorship Request Form
              </h1>
              <p style={styles.headerSub}>
                Please fill in all required details accurately. Submission does
                not guarantee approval.
              </p>
            </div>

            <div style={styles.formBody}>
              {/* ════════════════════════════════════════
              SECTION A — School Details
              Order matches spec:
              a. Name of School
              b. Address
              c. Principal Name
              d. Principal Phone & Email
              e. Coordinator Name
              f. Coordinator Phone & Email
              g. Classes From / To
              h. Total Students
              i. Total Teachers
              j. Board
              k. Type of School
          ════════════════════════════════════════ */}
              <div style={styles.sectionBlock}>
                <p style={styles.sectionTitle}>A. School Details</p>

                {/* a. Name of School */}
                <div style={{ ...styles.row, marginTop: 0 }}>
                  <div style={styles.col12}>
                    <label style={styles.label}>
                      a. Name of School <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="text"
                      placeholder="e.g. St. Xavier's High School"
                      value={form.schoolName}
                      onChange={update("schoolName")}
                    />
                  </div>
                </div>

                {/* b. Address */}
                <div style={styles.row}>
                  <div style={styles.col12}>
                    <label style={styles.label}>
                      b. Address <span style={styles.star}>*</span>
                    </label>
                    <FocusTextarea
                      placeholder="Full school address"
                      value={form.address}
                      onChange={update("address")}
                      style={{ minHeight: 70 }}
                    />
                  </div>
                </div>

                {/* c. Principal Name */}
                <div style={styles.row}>
                  <div style={styles.col12}>
                    <label style={styles.label}>
                      c. Name of the Principal / HOS{" "}
                      <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="text"
                      placeholder="Full name"
                      value={form.principalName}
                      onChange={update("principalName")}
                    />
                  </div>
                </div>

                {/* d. Principal Phone & Email */}
                <div style={styles.row}>
                  <div style={styles.col6}>
                    <label style={styles.label}>
                      d. Contact Number of Principal / HOS
                      <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      // type="tel"
                      // <input
                      type="text"
                      inputMode="numeric"
                      maxLength={10}
                      placeholder="+91 XXXXX XXXXX"
                      value={form.principalPhone}
                      onChange={update("principalPhone")}
                    />
                  </div>
                  <div style={styles.col6}>
                    <label style={styles.label}>
                      Email of Principal / HOS
                      <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="email"
                      placeholder="principal@school.edu"
                      value={form.principalEmail}
                      onChange={update("principalEmail")}
                    />
                  </div>
                </div>

                {/* e. Coordinator Name */}
                <div style={styles.row}>
                  <div style={styles.col12}>
                    <label style={styles.label}>
                      e. Name of the Coordinator
                      <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="text"
                      placeholder="Full name"
                      value={form.coordinatorName}
                      onChange={update("coordinatorName")}
                    />
                  </div>
                </div>

                {/* f. Coordinator Phone & Email */}
                <div style={styles.row}>
                  <div style={styles.col6}>
                    <label style={styles.label}>
                      f. Contact Number of Coordinator
                      <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      // type="tel"
                      type="text"
                      inputMode="numeric"
                      maxLength={10}
                      placeholder="+91 XXXXX XXXXX"
                      value={form.coordinatorPhone}
                      onChange={update("coordinatorPhone")}
                    />
                  </div>
                  <div style={styles.col6}>
                    <label style={styles.label}>
                      Email of Coordinator
                      <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="email"
                      placeholder="coordinator@school.edu"
                      value={form.coordinatorEmail}
                      onChange={update("coordinatorEmail")}
                    />
                  </div>
                </div>

                {/* g. Classes From / To */}
                <div style={styles.row}>
                  <div style={styles.col3}>
                    <label style={styles.label}>
                      g. Classes — From <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="text"
                      placeholder="e.g. 1"
                      value={form.classFrom}
                      onChange={update("classFrom")}
                    />
                  </div>
                  <div style={styles.col3}>
                    <label style={styles.label}>
                      Classes — To <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="text"
                      placeholder="e.g. 12"
                      value={form.classTo}
                      onChange={update("classTo")}
                    />
                  </div>
                </div>

                {/* h. Total Students */}
                <div style={styles.row}>
                  <div style={styles.col6}>
                    <label style={styles.label}>
                      h. Total Students
                      <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="number"
                      placeholder="e.g. 850"
                      value={form.totalStudents}
                      onChange={update("totalStudents")}
                      min="0"
                    />
                  </div>

                  {/* i. Total Teachers */}
                  <div style={styles.col6}>
                    <label style={styles.label}>
                      i. Total Teachers
                      <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="number"
                      placeholder="e.g. 45"
                      value={form.totalTeachers}
                      onChange={update("totalTeachers")}
                      min="0"
                    />
                  </div>
                </div>

                {/* j. Board */}
                <div style={styles.row}>
                  <div style={styles.col6}>
                    <label style={styles.label}>
                      j. Board <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="text"
                      placeholder="e.g. CBSE, ICSE, State Board"
                      value={form.board}
                      onChange={update("board")}
                    />
                  </div>

                  {/* k. Type of School */}
                  <div style={styles.col6}>
                    <label style={styles.label}>
                      k. Type of School <span style={styles.star}>*</span>
                    </label>
                    <FocusSelect
                      value={form.schoolType}
                      onChange={update("schoolType")}
                    >
                      <option value="">-- Select Type --</option>
                      <option value="Private">Private</option>
                      <option value="Government">Government</option>
                      <option value="Government Aided">Government Aided</option>
                    </FocusSelect>
                  </div>
                </div>
              </div>

              {/* ════════════════════════════════════════
              SECTION B — MyDocMaster Plan
          ════════════════════════════════════════ */}
              <div style={styles.sectionBlock}>
                <p style={styles.sectionTitle}>
                  B. Which School Plan of MyDocMaster would you like to opt for
                  under CSR Grant?
                </p>

                {/* 👇 Flex container */}
                <div style={styles.planList}>
                  {plans.map((plan) => {
                    const isSelected = form.selectedPlan === plan.value;
                    const isCustom = plan.value === "100+ Users";

                    return (
                      <div
                        key={plan.value}
                        style={{
                          ...styles.planCard,
                          ...(isSelected ? styles.planCardSelected : {}),
                          alignItems: "flex-start",
                        }}
                        onClick={() =>
                          setForm((p) => ({
                            ...p,
                            selectedPlan: plan.value,
                            customUserCount: isCustom ? p.customUserCount : "",
                          }))
                        }
                      >
                        {/* Radio */}
                        <input
                          type="radio"
                          name="plan"
                          checked={isSelected}
                          onChange={() => {}}
                          style={{ marginTop: 4, flexShrink: 0 }}
                        />

                        {/* Label */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                          }}
                        >
                          <span style={styles.planLabel}>{plan.label}</span>
                        </div>
                      </div>
                    );
                  })}

                  {/* ✅ Input shown ONLY when 100+ Users is selected */}
                </div>
                {form.selectedPlan === "100+ Users" && (
                  <div
                    style={{ marginTop: 12, maxWidth: 260 }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <label
                      style={{
                        ...styles.label,
                        fontSize: 11,
                        marginBottom: 5,
                      }}
                    >
                      Please specify count
                      <span style={styles.star}>*</span>
                    </label>

                    <FocusInput
                      type="number"
                      placeholder="e.g. 250"
                      value={form.customUserCount}
                      onChange={update("customUserCount")}
                      min="101"
                    />
                  </div>
                )}
              </div>

              <div style={styles.sectionBlock}>
                <p style={styles.sectionTitle}>
                  C. Other Grant / Sponsorship Details
                </p>
                {/* a. Type of Requirement */}
                <label style={styles.label}>
                  a. Type of Requirement (Select one){" "}
                  <span style={styles.star}>*</span>
                </label>
                {/* <div style={{ marginBottom: 16, marginTop: 8 }}>
              {reqTypes.map((type) => (
                <label
                  key={type}
                  style={{
                    ...styles.reqTypeLabel,
                    ...(form.requirementType === type
                      ? styles.reqTypeLabelSelected
                      : {}),
                  }}
                >
                  <input
                    type="radio"
                    name="reqType"
                    value={type}
                    checked={form.requirementType === type}
                    onChange={(e) =>
                      setForm((p) => ({
                        ...p,
                        requirementType: e.target.value,
                      }))
                    }
                  />
                  {type}
                  {type === "Other" && form.requirementType === "Other" && (
                    <FocusInput
                      type="text"
                      placeholder="Please specify"
                      value={form.otherReqText}
                      onChange={update("otherReqText")}
                      style={{ maxWidth: 220, marginLeft: 10 }}
                    />
                  )}
                </label>
              ))}
            </div> */}
                <div
                  style={{
                    ...styles.row,
                    marginTop: 8,
                    rowGap: 6, // ✅ controls vertical space between rows
                    columnGap: 16,
                  }}
                >
                  {reqTypes.map((type) => (
                    <div key={type} style={styles.col6}>
                      <label
                        style={{
                          ...styles.reqTypeLabel,
                          ...(form.requirementType === type
                            ? styles.reqTypeLabelSelected
                            : {}),
                        }}
                      >
                        <input
                          type="radio"
                          name="reqType"
                          value={type}
                          checked={form.requirementType === type}
                          onChange={(e) =>
                            setForm((p) => ({
                              ...p,
                              requirementType: e.target.value,
                            }))
                          }
                        />
                        &nbsp; {type}
                      </label>

                      {/* ✅ Show textarea ONLY when "Other" is selected */}
                      {type === "Other" && form.requirementType === "Other" && (
                        <>
                          <textarea
                            placeholder="Please describe your requirement"
                            value={form.otherReqText}
                            onChange={update("otherReqText")}
                            style={{
                              ...styles.textarea,
                              marginTop: 8,
                            }}
                          />
                        </>
                      )}
                    </div>
                  ))}
                </div>
                {/* b. Purpose */}
                <div style={{ marginBottom: 14 }}>
                  <label style={styles.label}>
                    b. Purpose of Grant / Sponsorship
                    <span style={styles.star}>*</span>
                  </label>
                  <FocusTextarea
                    placeholder="Describe the purpose..."
                    value={form.purpose}
                    onChange={update("purpose")}
                  />
                </div>
                {/* c. Project / Event Description */}
                <div style={{ marginBottom: 14 }}>
                  <label style={styles.label}>
                    c. Project / Event Description (Brief)
                    <span style={styles.star}>*</span>
                  </label>
                  <FocusTextarea
                    placeholder="Brief description of the project or event..."
                    value={form.projectDesc}
                    onChange={update("projectDesc")}
                  />
                </div>
                {/* d. Estimated Budget */}
                <div style={{ marginBottom: 14 }}>
                  <label style={styles.label}>
                    d. Estimated Budget / Requirement
                    <span style={styles.star}>*</span>
                  </label>
                  <FocusInput
                    type="text"
                    placeholder="e.g. ₹50,000"
                    value={form.budget}
                    onChange={update("budget")}
                  />
                </div>
                {/* e. Expected Outcomes */}
                <div style={{ marginBottom: 14 }}>
                  <label style={styles.label}>
                    e. Expected Outcomes
                    <span style={styles.star}>*</span>
                  </label>
                  <FocusInput
                    type="text"
                    placeholder="Key expected outcomes"
                    value={form.outcomes}
                    onChange={update("outcomes")}
                  />
                </div>
                {/* f/g/h. Benefits */}
                <div style={{ ...styles.row, marginTop: 0 }}>
                  <div style={styles.col4}>
                    <label style={styles.label}>
                      f. Benefits for Students{" "}
                      <span style={styles.star}>*</span>
                    </label>
                    <FocusTextarea
                      placeholder="..."
                      value={form.benefitStudents}
                      onChange={update("benefitStudents")}
                      style={{ minHeight: 70 }}
                    />
                  </div>
                  <div style={styles.col4}>
                    <label style={styles.label}>
                      g. Benefits for Teachers{" "}
                      <span style={styles.star}>*</span>
                    </label>
                    <FocusTextarea
                      placeholder="..."
                      value={form.benefitTeachers}
                      onChange={update("benefitTeachers")}
                      style={{ minHeight: 70 }}
                    />
                  </div>
                  <div style={styles.col4}>
                    <label style={styles.label}>
                      h. Benefits for School <span style={styles.star}>*</span>
                    </label>
                    <FocusTextarea
                      placeholder="..."
                      value={form.benefitSchool}
                      onChange={update("benefitSchool")}
                      style={{ minHeight: 70 }}
                    />
                  </div>
                </div>
              </div>

              {/* ════════════════════════════════════════
              DECLARATION
          ════════════════════════════════════════ */}
              <div style={styles.sectionBlock}>
                <p style={styles.sectionTitle}>Declaration</p>
                <div style={styles.declarationBox}>
                  <div
                    style={{ ...styles.row, marginTop: 0, marginBottom: 16 }}
                  >
                    <div style={styles.col6}>
                      <label style={styles.label}>
                        Name <span style={styles.star}>*</span>
                      </label>
                      <FocusInput
                        type="text"
                        placeholder="Full name of declarant"
                        value={form.declarantName}
                        onChange={update("declarantName")}
                      />
                    </div>
                    <div style={styles.col6}>
                      <label style={styles.label}>
                        Designation <span style={styles.star}>*</span>
                      </label>
                      <FocusInput
                        type="text"
                        placeholder="e.g. Principal, Coordinator"
                        value={form.declarantDesig}
                        onChange={update("declarantDesig")}
                      />
                    </div>
                  </div>

                  <p style={styles.declarationText}>
                    I{" "}
                    <strong style={{ color: "#1a3a5c" }}>
                      {form.declarantName || "[Name]"}
                    </strong>
                    ,{" "}
                    <strong style={{ color: "#1a3a5c" }}>
                      {form.declarantDesig || "[Designation]"}
                    </strong>
                    , declare that the information furnished above is true and
                    correct to the best of my knowledge. I understand that
                    submission of this form does not guarantee any grant /
                    sponsorship.
                  </p>

                  <label style={styles.checkLabel}>
                    <input
                      type="checkbox"
                      style={{ ...styles.checkInput, marginRight: "1.5%" }}
                      checked={form.checkApproval}
                      onChange={updateCheck("checkApproval")}
                    />
                    I am aware that DocMaster reserves the right to approve or
                    reject applications.
                  </label>

                  <label style={styles.checkLabel}>
                    <input
                      type="checkbox"
                      style={{ ...styles.checkInput, marginRight: "1.5%" }}
                      checked={form.checkPublish}
                      onChange={updateCheck("checkPublish")}
                    />
                    I also authorise DocMaster that, if desired for the purpose,
                    it may publish this data on their website(s) and may also
                    share the same with other Sponsors and CSR Funding
                    organisations.
                  </label>

                  <div style={{ marginTop: 16, maxWidth: 220 }}>
                    <label style={styles.label}>
                      Date <span style={styles.star}>*</span>
                    </label>
                    <FocusInput
                      type="date"
                      value={form.declarationDate}
                      onChange={update("declarationDate")}
                    />
                  </div>
                </div>
              </div>

              {/* ── BUTTONS ── */}
              <div
                style={{
                  display: "flex",
                  gap: 14,
                  flexWrap: "wrap",
                  marginTop: 8,
                }}
              >
                <button style={styles.btnPrimary} onClick={handleSubmit}>
                  Submit Application
                </button>
                {/* <button style={styles.btnSecondary} onClick={handleReset}> */}
                <button style={styles.btnSecondary} onClick={onClose}>
                  {/* Reset Form */}
                  Cancel
                </button>
              </div>
            </div>
          </div>

          {showToast && (
            <div style={styles.toast}>
              ✅ Form submitted! Check the browser console for details.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
